export default "__VITE_ASSET__4a485967__"